import { sendDeleteRequest, sendGetRequest, sendPostRequest, sendPutRequest } from '@/services/api.service'
import { API_LOCATOR } from '@/config/api.config'

export function getLocatorListAPI(clientId) {
  return sendGetRequest(`${API_LOCATOR.BASE_API_URL}/clients/${clientId}/${API_LOCATOR.LOCATOR}`)
}

export function getLocator(slug) {
  return sendGetRequest(`${API_LOCATOR.BASE_API_URL}/${API_LOCATOR.PUBLIC_LOCATORS}/${slug}`)
}

export function postLocator(clientId, payload) {
  return sendPostRequest(`${API_LOCATOR.BASE_API_URL}/clients/${clientId}/${API_LOCATOR.LOCATOR}`, payload)
}

export function deleteLocator(clientId, slug) {
  return sendDeleteRequest(`${API_LOCATOR.BASE_API_URL}/clients/${clientId}/${API_LOCATOR.LOCATOR}/${slug}`)
}

export function putLocator(clientId, payload, slug) {
  return sendPutRequest(`${API_LOCATOR.BASE_API_URL}/clients/${clientId}/${API_LOCATOR.LOCATOR}/${slug}`, payload)
}
